import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, ListItemIcon, ListItemText, ListItem } from '@material-ui/core';

class FHEListProduct extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        primary: PropTypes.string,
        secondary: PropTypes.string,
        thirdly: PropTypes.string,
        icon: PropTypes.object
    };

    static defaultProps = {
        secondary: '',
        primary: '',
        thirdly: '',
        icon: {}
    };

    render() {
        const { classes, primary, secondary, thirdly, icon } = this.props;
        return (
            <ListItem button className={classes.item}>
                <ListItemIcon>
                    <div className={classes.icon}>{icon}</div>
                </ListItemIcon>
                <ListItemText primary={primary} secondary={secondary} />
                {thirdly !== '' ? <span className={classes.thirdly}>{thirdly}</span> : null}
            </ListItem>
        );
    }
}

const styles = () => ({
    icon: {
        margin: '0 auto',
        marginRight: 20
    },
    texts: {
        fontSize: 19,
        color: 'white'
    },
    thirdly: {
        marginLeft: 30
    }
});

export default withStyles(styles, { withTheme: true })(FHEListProduct);



// WEBPACK FOOTER //
// ./data/components/FHEListProduct.js